export const semanticColorTokens = {
  bg: {
    vault: {
      default: 'white',
    },
    navbar: {
      default: 'neutral100',
    },
  },
};
